// import { createRoot } from 'react-dom/client';
//
// const elements: Record<symbol, HTMLDivElement> = {};
//
// export default function addComponent(
//   callback: (remove: () => void) => JSX.Element
// ) {
//   const key = Symbol('elm_key');
//   elements[key] = document.createElement('div');
//   document.body.appendChild(elements[key]);
//   const root = createRoot(elements[key]);
//   const element = callback(() => {
//     if (!elements[key]) return;
//     root.unmount();
//     elements[key].parentNode?.removeChild(elements[key]);
//     delete elements[key];
//   });
//   root.render(element);
// }

import ReactDom from 'react-dom';

const elements: Record<symbol, HTMLDivElement> = {};

const createRemoveHandler = (key: symbol) => () => {
  if (!elements[key]) return;
  ReactDom.unmountComponentAtNode(elements[key]);
  elements[key].parentNode?.removeChild(elements[key]);
  delete elements[key];
};

export default function addComponent(
  callback: (remove: () => void) => JSX.Element
) {
  const key = Symbol('elm_key');
  elements[key] = document.createElement('div');
  const element = callback(createRemoveHandler(key));
  document.body.appendChild(elements[key]);
  ReactDom.render(element, elements[key]);
}
